import styled from 'styled-components';

export const LandingPageVideoModules = styled.div`
  background: #FFF6FB;
  padding: 40px 10%;
  width: 100%;
  min-height: 100vh;

  .container-content {
    display: grid;
    grid-template-columns: 1fr 400px;
    gap: 40px;
    max-width: 1400px;
    margin: 0 auto;
  }

  .modules-section {
    h1 {
      font-size: 28px;
      font-weight: 700;
      color: #807F7E;
      margin-bottom: 0px;
    }

    p {
      color: #807F7E;
      margin: 10px 0px 24px 0px;
    }

    .modules-dropdown {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  
.info-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 400px;

  @media (max-width: 768px) {
    width: 100% !important;
  }
}

/* Detalhes do Curso - Card Principal Rosa */
.course-details {
  background: linear-gradient(135deg, #f8bbd9 0%, #f472b6 100%);
  border-radius: 16px;
  padding: 20px;
  color: white;
}

.course-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: white;
}

.stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.stat-item {
  border-radius: 12px;
  padding: 16px 12px;
  text-align: center;
  color: white;
}

.bg-icon{
  background: linear-gradient(90deg, rgba(94, 40, 126, 0.8) 0%, rgba(216, 46, 136, 0.8) 100%);
  padding: 16px 12px;
  border-radius: 12px;
  margin-bottom: 10px;
  
}



.stat-main-label {
  font-size: 14px;
  font-weight: 600;
  
  margin-bottom: 2px;
}

.stat-sublabel {
  font-size: 10px;
  opacity: 0.7;
}

/* O que está incluído */
.included-section {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.included-title {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 16px;
}

.included-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.included-item {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.check-icon {
  color: #10b981;
  font-weight: 600;
  margin-top: 1px;
  flex-shrink: 0;
}

/* Condição Especial */

.special-section {
  background: linear-gradient(135deg, #D82E88 0%, #40909F 100%);
  border-radius: 16px;
  padding: 20px;
  color: white;
  text-align: start;
}

.special-badge {
  padding: 4px 10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  
}

.special-text {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 16px;
  opacity: 0.95;
  font-weight: 400;
}

.button-container{
  display:flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;
}

.cta-button {
  background: rgba(255, 255, 255, 0.95);
  color: #D82E88;
  border: none;
  border-radius: 16px;
  padding: 10px 18px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 50%;
  margin-bottom: 6px;
  
  &:hover {
    transform: translateY(-1px);
    background: white;
  }
}

.guarantee-text {
  font-size: 10px;
  opacity: 0.8;
  font-weight: 600;
}


  @media (max-width: 1024px) {
    .container-content {
      grid-template-columns: 1fr;
      gap: 32px;
    }
  }

  @media (max-width: 768px) {
    padding: 20px 5%;
    
    .stats-cards {
      grid-template-columns: 1fr;
    }
  }
`;

export const LandingPageModuleCard = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #fce7f3;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }

  .module-header {
    padding: 24px;
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .module-icon {
    background: #fce7f3;
    padding: 12px;
    border-radius: 8px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 24px;
      height: 24px;
      color: #ec4899;
    }
  }

  .module-content {
    flex: 1;
    min-width: 0;
  }

  .module-main {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .module-info {
    flex: 1;
  }

  .module-title {
    font-size: 22px;
    font-weight: 700;
    color: #807F7E;
    margin-bottom: 4px;
    line-height: 1.3;
  }

  .module-subtitle {
    font-size: 14px;
    font-weight: 600;
    color: #D82E88 !important;
    margin-bottom: 0px !important;
  }

  .module-description {
    font-size: 14px;
    color: #6b7280;
    line-height: 1.5;
  }

  .view-link {
    background: none;
    border: none;
    font-size: 14px;
    font-weight: 500;
    color: #ec4899;
    cursor: pointer;
    padding: 0;
    transition: color 0.2s ease;

    &:hover {
      color: #db2777;
    }
  }

  .module-controls {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    flex-shrink: 0;
  }

  .lessons-badge {
    background: #ec4899;
    color: white;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
  }

  .expand-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
       color: #ec4899;
    }

    svg {
      width: 20px;
      height: 20px;
       color: #ec4899;
      transition: all 0.3s ease;
      
      &.rotated {
        transform: rotate(180deg);
      }
    }

 
  }

  .expandable-content {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;

    &.expanded {
      max-height: 600px;
      opacity: 1;
    }
  }

  .content-inner {
    padding: 0 24px 24px;
  }

  .divider {
    height: 1px;
    background: #fce7f3;
    margin-bottom: 16px;
  }

  .lessons-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .lesson-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #fef7ff;
    }

    svg {
      width: 16px;
      height: 16px;
      color: #f9a8d4;
      transition: color 0.2s ease;
      flex-shrink: 0;
    }

    &:hover svg {
      color: #ec4899;
    }

    span {
      font-size: 14px;
      color: #4b5563;
      transition: color 0.2s ease;
    }

    &:hover span {
      color: #111827;
    }
  }

  .empty-content {
    text-align: center;
    padding: 32px 0;
    color: #9ca3af;
    font-size: 14px;
  }

  @media (max-width: 768px) {
    .module-header {
      padding: 20px;
      flex-direction: column;
      gap: 16px;
    }

    .module-main {
      flex-direction: column;
      gap: 16px;
    }

    .module-controls {
      align-self: stretch;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .module-title {
      font-size: 16px;
    }

    .content-inner {
      padding: 0 20px 20px;
    }
  }

  @media (max-width: 480px) {
    .module-header {
      padding: 16px;
    }

    .module-icon {
      padding: 10px;

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .content-inner {
      padding: 0 16px 16px;
    }
  }
`;